/*
 * Сколько правок назначено чтецу в проекте — единое правило для значка чтеца (readerState),
 * внесения сессии «правки» (recordAmount) и шага «Правки» в старом окне сессий.
 */

/** Чтецов в проекте, с которых число правок задаётся у каждого чтеца отдельно */
const MULTI_VOICE_FROM = 2;

/**
 * В многоголосом проекте — своё число чтеца (reader_edits_number), в одноголосом — число проекта (corrections_number).
 * null — не указано (нет значения, не число или отрицательное); 0 — «правок нет».
 */
export function readerAssignedCorrections(args: {
  readerEditsNumber: number | null | undefined;
  projectCorrectionsNumber: number | null | undefined;
  readersCount: number;
}): number | null {
  const value = args.readersCount >= MULTI_VOICE_FROM ? args.readerEditsNumber : args.projectCorrectionsNumber;
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}
